export const blockIconsImagePortrait = (
	<span className='material-symbols-outlined'>portrait</span>
);
